var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.162,
    height: 10.162,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 0 5.08105)",
    fill: "#69D1FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79012 10.162L17.5803 5.081L17.6923 15.243L8.79012 20.3241L8.79012 10.162Z",
    fill: "#82D9FD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.162,
    height: 10.162,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 8.80083 0)",
    fill: "#A6E4FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.2b92050f3e6b9971c5fbff61d66471be.svg";
export { ForwardRef as ReactComponent };